'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' });

var MarkunreadMailbox = function MarkunreadMailbox(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

MarkunreadMailbox = (0, _pure2.default)(MarkunreadMailbox);
MarkunreadMailbox.muiName = 'SvgIcon';

exports.default = MarkunreadMailbox;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/MarkunreadMailbox.js
// module id = 2606
// module chunks = 0